<template>
  <div v-if="discountValue" class="sale-badge-component">
    <div class="sale-badge">{{ texts.onSale }} {{ discountValue }}</div>
  </div>
</template>

<script lang="ts" setup>
import type { ProductDetails } from '~/types/Product'
import type { PropType } from 'vue'
import { useLang } from '~/composables/useLang'
import getDiscount from '~/utils/getDiscount'

const { t } = useLang()

const props = defineProps({
  productDetails: {
    type: Object as PropType<ProductDetails>,
    required: true,
  },
})

const discountValue = computed(() => {
  return getDiscount(props.productDetails?.current_price, props.productDetails?.old_price)
})

const texts = computed(() => {
  return {
    onSale: t('product.on_sale'),
  }
})
</script>

<style lang="postcss" scoped>
.sale-badge-component {
  @apply absolute top-0 left-0 z-[2];
  .sale-badge {
    @apply flex items-center bg-brand-primary rounded-full text-white font-bold px-[1.125rem] py-[0.4375rem] leading-tight;
  }
}

.tp .sale-badge-component {
  .sale-badge {
    @apply bg-green rounded-md;
  }
}
</style>
